
import { Vue, Component, Prop } from 'vue-property-decorator';
import Icon from '@/components/Icons/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class Alert extends Vue {
  @Prop(Boolean)
  inline?: boolean;

  @Prop(Boolean)
  small?: boolean;

  @Prop(String)
  icon?: string;

  @Prop({ type: String, default: 'alert__header--regular' })
  titleClass?: string;

  @Prop(String)
  maxWidth?: string;

  @Prop({ default: 'success' })
  type?: 'success' | 'info' | 'warning' | 'error';

  get classObject(): Array<string | { [key: string]: boolean | undefined }> {
    return [
      `qr-alert--${this.type}`,
      {
        'qr-alert--small': this.small,
        'd-inline-flex': this.inline,
      },
    ];
  }
}
